const login_pt = require('./login.json')
export default login_pt